import classNames from "classnames";
import styles from "./styles.module.scss";
import NeedHelp from "shared/components/supportComponent/needHelp";
import Contact from "shared/components/supportComponent/contact";

const ContactSupport = () => {
  return (
    <div
      className={classNames(
        styles.mainContainer,
        "flex-col md:flex-row",
        styles.containerPadding
      )}
    >
      <NeedHelp />
      <Contact />
    </div>
  );
};

export default ContactSupport;
